import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import {
  getCwisUrl,
  getTimeZoneCodeOffset,
  getParameterCodes,
  getParameterCodeInfo,
  getValueFlagDescription,
} from "../../../utils";

import {
  generateMedia,
  renderTooltipFieldbySiteId,
} from "../../../utils/tooltip";

import "react-tabs/style/react-tabs.css";
import classes from "./NonNgwosSiteTooltip.module.css";

const NonNgwosSiteTooltip = ({ tooltipInfo }) => {
  const [lastObs, setLastObs] = useState(null);
  const [siteSpecificTabs, setSiteSpecificTabs] = useState(null);
  const [lastObsCwis, setLastObsCwis] = useState(null);
  const [tsId, setTsId] = useState(null);
  const [tooltipTabs, setTooltipTabs] = useState([]);
  const [showNWSModal, setShowNWSModal] = useState(false);
  const [showHivisImageModal, setShowHivisImageModal] = useState(false);
  const layerState = useSelector((state) => state.layers);
  const dataSlice = useSelector((state) => state.data);

  const hivisData = dataSlice.hivisCameras.data;
  let activeLayers = Object.keys(layerState).filter(
    (id) => layerState[id].showLayer
  );

  const [showText, setShowText] = useState(true);
  const [showMedia, setShowMedia] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showImage, setShowImage] = useState(false);

  const handleListClick = () => {
    setShowText(true);
    setShowMedia(false);
    setShowVideo(false);
    setShowImage(false);
  };

  const handleImageClick = () => {
    setShowText(false);
    setShowMedia(true);
    setShowVideo(false);
    setShowImage(true);
  };

  const handleVideoClick = () => {
    setShowText(false);
    setShowMedia(true);
    setShowVideo(true);
    setShowImage(false);
  };

  const handleToggleNWSModal = () => {
    setShowNWSModal((prevState) => !prevState);
  };
  const handleToggleHivisModal = () => {
    setShowHivisImageModal((prevState) => !prevState);
  };
  const renderAoiField = (field) => {
    return <p className={classes["aoi"]}>{field.value}</p>;
  };

  const generateHeader = (title, siteId, expanded) => {
    let isMedia;
    if (siteId) {
      // check if video exists for site
      const siteInfo = hivisData
        ? hivisData.filter((site) => site.nwisId === siteId)
        : [];
      isMedia = siteInfo.length > 0;
    }

    return (
      <>
        <div className={classes["title-group"]}>
          <p
            className={`${classes["title"]}  ${
              isMedia ? classes["title-50"] : classes["title-100"]
            }`}
          >
            {`${title} ${
              !expanded && tooltipInfo.hasSiteId ? "(" + siteId + ")" : ""
            }`}
          </p>
          {isMedia && (
            <div className={classes["icon-group"]}>
              <i
                className={`fas fa-list-ul icon
    ${showText ? classes["active"] : ""}`}
                onClick={handleListClick}
              />
              <i
                className={`fas fa-camera icon
    ${showImage ? classes["active"] : ""}`}
                onClick={handleImageClick}
              />
              <i
                className={`fas fa-video icon
    ${showVideo ? classes["active"] : ""}`}
                onClick={handleVideoClick}
              />
            </div>
          )}
        </div>
        {!expanded && (
          <>
            <p className={classes["title-group-subtitle"]}>
              Click for more info
            </p>
          </>
        )}
      </>
    );
  };

  const generateGwisPlot = (siteId, layerId, tsId) => {
    // const pcode = getParameterCodes(siteId, layerId);
    // GWIS options, see https://txpub.usgs.gov/dss/gwis/0.0/doc/#samples?10
    // const opts = {
    //   // ...data options...
    //   iv_or_dv: "dv",
    //   // start_dt : "2022-03-01",
    //   // end_dt   : "2022-03-02",
    //   // ...plot lines...
    //   series: [
    //     {
    //       // site: siteId,
    //       site: "06696980",
    //       // pcode: pcode ? pcode.code : "00065", // default to 00065 for now
    //       // pcode: "00065", // default to 00065 for now
    //     },
    //   ],
    //   // ...plot options...
    //   ylabel: pcode ? pcode.label : "",
    //   legend: "onmouseover",
    //   range_selector: false,
    //   y_logscale: false,
    //   y_show0: false,
    //   x_grid: false,
    //   y_grid: false,
    //   controls: ["y_logscale", "y_show0"],
    // };
    tsId = tsId ? tsId : "all";
    return (
      <iframe
        // style={{ overflowY: "hidden" }}
        src={`https://dashboard.waterdata.usgs.gov/api/gwis/2.0/service/site?agencyCode=USGS&siteNumber=${siteId}&banner=false&pad=false&open=${tsId}&period=pt12h`}
        title={"GWIS 2.0 realtime data"}
        id="tooltipGWIS"
        className={`${classes["embedded-content"]} ${classes["iframe"]}`}
      ></iframe>
    );
  };

  async function getMostRecentData(siteId, layerId) {
    let parameterCodes = getParameterCodes(
      siteId,
      layerId,
      layerState,
      dataSlice
    );
    const url = `https://labs.waterdata.usgs.gov/sta/v1.1/Things('USGS-${siteId}')/Datastreams`;

    try {
      const response = await axios.get(url);
      const dataArray = response.data.value;
      // get metadata for specific parameter code
      let parameterMetadata = null;
      if (dataArray.length > 0) {
        // if expected parameterCode is among those present in the data array,
        //   filter to that parameter, otherwise return first entry
        if (parameterCodes !== null) {
          // sort parameter codes by priority, ascending order
          parameterCodes = parameterCodes.sort(
            (a, b) => a.priority - b.priority
          );

          // loop through sorted parameter codes array and filter dataArray to that parameter.
          // return first entry
          parameterMetadata = parameterCodes.map((codeData) =>
            dataArray.filter(
              (entry) => entry.properties.ParameterCode === codeData.code
            )
          )[0][0];
        }
        // since there's no guarantee that all sites with primary site category="x" have the specified
        //   parameter code, default to the first entry if no metadata for the specified code is found
        parameterMetadata = parameterMetadata
          ? parameterMetadata
          : dataArray[0];
      }

      if (parameterMetadata !== null) {
        let observationsUrl =
          parameterMetadata["Observations@iot.navigationLink"];
        observationsUrl =
          observationsUrl + "?$orderby=phenomenonTime desc&$top=1";
        const lastObsResponse = await axios.get(observationsUrl);
        // console.log(lastObsResponse)
        return (
          <p>
            Last Observation:{" "}
            {lastObsResponse.data
              ? lastObsResponse.data.value[0].result
              : "not found"}{" "}
            at{" "}
            {lastObsResponse.data
              ? lastObsResponse.data.value[0].phenomenonTime
              : "not found"}
          </p>
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  // returns a site's recent observation and related info
  async function getMostRecentDataCwis(siteId, layerId) {
    // age threshold for built-in features (tooltip, popups, marker colors)
    const ageHoursMax = 4;
    let parameterCodes = getParameterCodes(
      siteId,
      layerId,
      layerState,
      dataSlice
    );
    const url = getCwisUrl(siteId);

    try {
      // make cwis api call
      const response = await axios.get(url);
      const dataArray = response.data.value;
      let data = null;
      // get info about site parameter of interest
      if (dataArray.length > 0) {
        if (parameterCodes !== null) {
          // sort parameter codes by priority, ascending order
          parameterCodes = parameterCodes.sort(
            (a, b) => a.priority - b.priority
          );

          // loop through sorted parameter codes array and filter dataArray to that parameter.
          // return first entry
          data = parameterCodes.map((pCodeItem) =>
            dataArray.filter((entry) => entry.ParameterCode === pCodeItem.code)
          );
          data = data.filter((arr) => arr.length > 0)[0][0];
        }

        // take first entry of site metadata if expected parameter code isn't found
        data = data ? data : dataArray[0];

        let timeAgo = "";
        let valueFlagDescription = getValueFlagDescription(data.ValueFlagCode);
        let directionOfChange = "Steady";
        if (data["RateOfChangeUnitPerHour"] > 0) {
          directionOfChange = "Increasing";
        } else if (data["RateOfChangeUnitPerHour"] < 0) {
          directionOfChange = "Decreasing";
        }

        const TimeUtc = data.TimeLocal.replace(
          /Z$/u,
          getTimeZoneCodeOffset(data.TimeZoneCode)
        );

        data.AgeHours = (Date.now() - Date.parse(TimeUtc)) / 3600000;
        timeAgo =
          data.AgeHours < 1
            ? `${Math.ceil(60 * data.AgeHours)} minutes ago`
            : `${data.AgeHours.toFixed(1)} hours ago`;
        data.ParameterUnit = getParameterCodeInfo(data.ParameterCode).unit;
        data.ParameterLabel = getParameterCodeInfo(data.ParameterCode).name;

        // set ts_id for opening the right GWIS 2.0 plot
        setTsId(data.CurrentConditionID);
        // return recent observation section of tooltip
        return data.AgeHours < ageHoursMax ? (
          <div className={classes["lastObsContainer"]}>
            <p>{data.ParameterLabel} </p>
            <p className={classes["lastObs"]}>
              {data.Value} @{" "}
              {" " +
                data.TimeLocal.split("T")
                  .pop()
                  .replace(/:[0-9]{2}Z$/u, "") +
                " " +
                data.TimeZoneCode +
                " "}
              {/* increasing / decreasing arrow  */}
              <i
                className={`${
                  directionOfChange === "Increasing"
                    ? `fas fa-arrow-up ${classes["arrow-up"]}`
                    : ""
                }  ${
                  directionOfChange === "Decreasing"
                    ? `fas fa-arrow-down ${classes["arrow-down"]}`
                    : ""
                }  ${
                  directionOfChange === "Steady"
                    ? `fas fa-arrow-right ${classes["arrow-right"]}`
                    : ""
                }`}
              ></i>
            </p>
            <p>{timeAgo}</p>
            <p>
              {directionOfChange}{" "}
              {directionOfChange !== "Steady"
                ? "at " +
                  Math.abs(data.RateOfChangeUnitPerHour.toPrecision(2)) +
                  " " +
                  data.ParameterUnit +
                  " per hour"
                : ""}
            </p>
            {data.ValueFlagCode && (
              <p className={classes["value-flag"]}>
                {valueFlagDescription.description}
              </p>
            )}
          </div>
        ) : (
          <p className={classes["lastObsUnavailable"]}>
            Recent measurement unavailable
          </p>
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  const getSiteSpecificTabs = (siteId, layerId) => {
    let newSiteSpecificTabs = [];
    // check if layer has additional tabs
    const additionalTabsConfig =
      "additionalTooltipTabs" in layerState[layerId]
        ? layerState[layerId].additionalTooltipTabs
        : null;

    // find site
    const dataName = layerState[layerId].data;
    if (dataSlice[dataName].data !== null) {
      const site = dataSlice[dataName].data.features.find(
        (feat) =>
          feat.properties[layerState[layerId].siteNumberField] === siteId
      );
      if (site) {
        // check if additional tabs should be included for given site
        if (additionalTabsConfig) {
          additionalTabsConfig.forEach((tabConfig) => {
            if (
              site.properties[tabConfig.showWhen.field] ===
              tabConfig.showWhen.value
            ) {
              // must be array of objects with name, layerId and type props
              // setSiteSpecificTabs([{ name: tab.name, layerId: tab.layerId, type: tab.type }])
              newSiteSpecificTabs.push({
                name: tabConfig.name,
                layerId: layerId,
                type: "siteSpecific",
              });
            }
          });
        }
      }
    }
    setSiteSpecificTabs(newSiteSpecificTabs);
  };

  // perform state updates on tooltipInfo change
  useEffect(() => {
    // make sensorthings API call to get most recent observation when new site is clicked
    if (
      tooltipInfo.siteId &&
      tooltipInfo.layerId &&
      tooltipInfo.type === "click" &&
      tooltipInfo.hasSiteId // siteId defaults to the id of the field if no actual siteId found
    ) {
      getMostRecentData(tooltipInfo.siteId, tooltipInfo.layerId).then(
        (data) => {
          setLastObs(data);
        }
      );
      getMostRecentDataCwis(tooltipInfo.siteId, tooltipInfo.layerId).then(
        (data) => {
          setLastObsCwis(data);
        }
      );

      // check if the site/layer combo has site-specific tabs (e.g. NWS site info)
      getSiteSpecificTabs(tooltipInfo.siteId, tooltipInfo.layerId);
    } else {
      setLastObs(null);
      setLastObsCwis(null);
      setSiteSpecificTabs([]);
    }

    // reset showText and showMedia when new site is opened
    setShowText(true);
    setShowMedia(false);
    setShowVideo(false);
    setShowImage(false);
  }, [tooltipInfo]);

  // update tooltipTabs based on presence or absence of realtime data, nws site
  useEffect(() => {
    let newTooltipTabs = [];
    if (lastObs) {
      newTooltipTabs.push({
        name: "Realtime Data",
        layerId: null,
        type: "realtime",
      });
    }
    if (siteSpecificTabs) {
      newTooltipTabs = newTooltipTabs.concat(siteSpecificTabs);
      // siteSpecificTabs.forEach((tab) => {
      //   newTooltipTabs.push({ name: tab.name, layerId: tab.layerId, type: tab.type });
      // })
    }

    activeLayers.forEach((id) => {
      if (
        layerState[id].tooltipFields.filter((field) => field.section === "tabs")
          .length > 0 &&
        id === tooltipInfo.layerId
      ) {
        newTooltipTabs.push({
          name: layerState[id].name,
          layerId: id,
          type: "pointLayer",
        });
      }
    });
    setTooltipTabs(newTooltipTabs);
  }, [lastObs, siteSpecificTabs]);

  return (
    tooltipInfo.tooltipText && (
      <div
        className={`${classes["tooltip"]}  ${
          tooltipInfo.type === "click" ? classes["site-clicked"] : ""
        }`}
      >
        <div className={classes["site-info"]}>
          {tooltipInfo.tooltipText.map(
            (field) =>
              field.type === "title" &&
              field.value &&
              tooltipInfo.type !== "aoi" &&
              generateHeader(
                field.value,
                tooltipInfo.siteId,
                tooltipInfo.type === "click"
              )
          )}
          {/* handle AOI tooltip case  */}
          {tooltipInfo.type === "aoi" &&
            tooltipInfo.tooltipText.map((field) => {
              return renderAoiField(field);
            })}

          {/* normal tooltip for sites */}
          {showText &&
            tooltipInfo.type === "click" &&
            layerState[tooltipInfo.layerId].tooltipFields
              .filter(
                (field) =>
                  field.section === "main" &&
                  field.type !== "title" &&
                  field.type !== "link"
              )
              .map((field) => {
                return renderTooltipFieldbySiteId({
                  field,
                  layerId: tooltipInfo.layerId,
                  siteId: tooltipInfo.siteId,
                  classes,
                  dataSlice,
                  layerState,
                  handleToggleNWSModal,
                  showNWSModal,
                });
              })}

          {/* Separately render links, wrapped in container for flex-box display on single line */}
          {showText && tooltipInfo.type === "click" && (
            <div className={classes["links-container"]}>
              {layerState[tooltipInfo.layerId].tooltipFields
                .filter(
                  (field) => field.section === "main" && field.type === "link"
                )
                .map((field) => {
                  return renderTooltipFieldbySiteId({
                    field,
                    layerId: tooltipInfo.layerId,
                    siteId: tooltipInfo.siteId,
                    classes,
                    dataSlice,
                    layerState,
                    handleToggleNWSModal,
                    showNWSModal,
                  });
                })}
            </div>
          )}
          {/* most recent observation */}
          {showText && tooltipInfo.type === "click" && lastObsCwis}
          {showMedia &&
            tooltipInfo.type === "click" &&
            generateMedia({
              siteId: tooltipInfo.siteId,
              mediaType: showImage ? "image" : "video",
              hivisData,
              classes,
              handleToggleHivisModal,
              showHivisImageModal,
            })}
        </div>
        {tooltipInfo.type !== "aoi" &&
          tooltipInfo.type === "click" &&
          tooltipTabs.length > 0 && (
            <div className={classes["tabs-container"]}>
              <Tabs>
                <TabList>
                  {tooltipTabs.map((tab) => (
                    <Tab selectedClassName={classes["tab-selected"]}>
                      <span className={classes["tab-name"]}>{tab.name}</span>
                    </Tab>
                  ))}
                </TabList>
                {tooltipTabs.map((tab) => {
                  return (
                    <TabPanel>
                      <div
                        className={` ${classes["tab-content"]} ${
                          tab.type === "realtime" ? classes["tab-iframe"] : ""
                        }  ${
                          tab.type === "pointLayer"
                            ? classes["tab-pointlayer"]
                            : ""
                        } `}
                      >
                        {/* Realtime data tab panel */}
                        {tab.type === "realtime" &&
                          tooltipInfo.type === "click" &&
                          generateGwisPlot(
                            tooltipInfo.siteId,
                            tooltipInfo.layerId,
                            tsId
                          )}

                        {/* site-specific tab panels */}
                        {tab.type === "siteSpecific" &&
                          tooltipInfo.type === "click" && (
                            // filter additionalTooltipTabs to the current tab name and then render all fields associated with that tab
                            <div className={classes["tab-content__fit"]}>
                              {layerState[tab.layerId].additionalTooltipTabs
                                .filter(
                                  (tabConfig) => tabConfig.name === tab.name
                                )[0]
                                .fields.map((field) =>
                                  renderTooltipFieldbySiteId({
                                    field,
                                    layerId: tooltipInfo.layerId,
                                    siteId: tooltipInfo.siteId,
                                    classes,
                                    dataSlice,
                                    layerState,
                                    handleToggleNWSModal,
                                    showNWSModal,
                                  })
                                )}
                            </div>
                          )}

                        {/* tab panel for each active layer */}
                        {tab.type === "pointLayer" &&
                          layerState[tab.layerId].tooltipFields.map((field) => {
                            return (
                              tooltipInfo.siteId &&
                              field.section === "tabs" &&
                              renderTooltipFieldbySiteId({
                                field,
                                layerId: tooltipInfo.layerId,
                                siteId: tooltipInfo.siteId,
                                classes,
                                dataSlice,
                                layerState,
                                handleToggleNWSModal,
                                showNWSModal,
                              })
                            );
                          })}
                      </div>
                    </TabPanel>
                  );
                })}
              </Tabs>
            </div>
          )}
      </div>
    )
  );
};

export default NonNgwosSiteTooltip;
